import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlanner } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { AwardAlert } from '~weekly-planner/lib/common';

export const typePrefix = 'weekly-planner-award-alerts';

type Request = Record<string, unknown> | undefined;

export const awardAlertsApi = createApi({
  reducerPath: 'weeklyPlannerAwardAlertsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlanner }),
  tagTypes: ['awardAlerts', 'awardAlertTypes'],
  endpoints: (builder) => ({
    getAwardAlerts: builder.query<AwardAlert[], Request>({
      query: (params) => ({ url: '/users/award-alerts', method: 'GET', params }),
      providesTags: [{ type: 'awardAlerts', id: 'LIST' }],
      transformResponse: (payload) => unwrap<AwardAlert[]>(payload),
    }),
    getAwardAlertTypes: builder.query<AwardAlert[], void>({
      query: (params) => ({ url: '/award-alerts', method: 'GET', params }),
      providesTags: [{ type: 'awardAlertTypes', id: 'LIST' }],
      transformResponse: (payload) => unwrap<AwardAlert[]>(payload),
    }),
  }),
});

export const { useGetAwardAlertsQuery, useGetAwardAlertTypesQuery } = awardAlertsApi;
